module.exports = __webpack_public_path__ + "images/marker-current.006bb3.png";